import cn from 'classnames';
import React, {FC} from 'react';

import './progress-bar.less';

interface IProgressBarProps {
    value: number;
    maximum: number;
    barColor?: string;
}
export const ProgressBar: FC<IProgressBarProps> = ({maximum, value, barColor}: IProgressBarProps) => {
    const width = !maximum ? 0 : `${(value / maximum) * 100}%`;
    return (
        <div className={cn('progress-list-statistics__body__item__progress-bar')}>
            <div
                style={{width, backgroundColor: barColor ?? '#1E72D7'}}
                className={cn('progress-list-statistics__body__item__progress-bar__bar')}
            />
        </div>
    );
};
